/**
 * Landing Page Scripts
 *
 * - Smooth scroll for .scroll-to links (accounts for sticky nav)
 * - Match-height utility
 * - Form validation & phone formatting
 * - AJAX form submission to WP admin-ajax.php
 *
 * Depends on: landerPageData (wp_localize_script) for ajaxUrl, nonce, thankYou
 */
document.addEventListener("DOMContentLoaded", function () {

    /* ======================================================================
       Smooth Scroll (accounts for fixed lander-nav)
       ====================================================================== */
    var nav = document.querySelector(".lander-nav");
    var navHeight = nav ? nav.getBoundingClientRect().height : 80;

    document.querySelectorAll(".scroll-to").forEach(function (link) {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            var href = this.getAttribute("href");
            var target = document.querySelector(href);
            if (!target) return;
            var top = target.getBoundingClientRect().top + window.pageYOffset - navHeight - 10;
            window.scrollTo({ top: top, behavior: "smooth" });
        });
    });


    /* ======================================================================
       Match Height
       ====================================================================== */
    var matchEls = document.querySelectorAll(".match-height");
    var groups = {};

    matchEls.forEach(function (el) {
        var g = el.getAttribute("data-matchheight-group");
        if (!groups[g]) groups[g] = [];
        groups[g].push(el);
    });

    function matchHeights(group) {
        var max = 0;
        group.forEach(function (el) {
            el.style.height = "auto";
            var h = el.getBoundingClientRect().height;
            if (h > max) max = h;
        });
        group.forEach(function (el) { el.style.height = max + "px"; });
    }

    Object.values(groups).forEach(matchHeights);
    window.addEventListener("resize", function () {
        Object.values(groups).forEach(matchHeights);
    });


    /* ======================================================================
       Form Elements
       ====================================================================== */
    var form           = document.getElementById("lander-lead-form");
    var firstNameInput = document.getElementById("first_name");
    var lastNameInput  = document.getElementById("last_name");
    var emailInput     = document.getElementById("email");
    var phoneInput     = document.getElementById("primary_phone");
    var submitBtn      = document.getElementById("submit_button");

    if (!form || !firstNameInput) return; // guard — no form on page


    /* ======================================================================
       URL Parameter → Hidden Input Hydration
       Populates #dynamicInputs from window.location.search so tracking params
       are captured even when the page HTML is served from cache (WP Rocket,
       CDN, etc.) and PHP didn't see $_GET at render time. Existing hidden
       inputs are preserved; empty ones get filled, and missing ones are
       appended.
       ====================================================================== */
    var dynamicInputs = document.getElementById("dynamicInputs");
    if (dynamicInputs && window.location.search) {
        var urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach(function (value, key) {
            if (!value) return;
            var existing = form.querySelector('input[name="' + CSS.escape(key) + '"]');
            if (existing) {
                if (!existing.value) existing.value = value;
            } else {
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = value;
                dynamicInputs.appendChild(input);
            }
        });
    }


    /* ======================================================================
       Phone Number Auto-Formatting
       ====================================================================== */
    phoneInput.addEventListener("input", function (e) {
        var raw = e.target.value.replace(/\D/g, "").substring(0, 10);
        var formatted = raw;

        if (raw.length >= 7) {
            formatted = "(" + raw.substring(0, 3) + ") " + raw.substring(3, 6) + "-" + raw.substring(6);
        } else if (raw.length >= 4) {
            formatted = "(" + raw.substring(0, 3) + ") " + raw.substring(3);
        } else if (raw.length > 0) {
            formatted = "(" + raw;
        }

        e.target.value = formatted;

        var hidden = document.getElementById("primary-phone-unformatted");
        if (hidden) hidden.value = raw;
    });


    /* ======================================================================
       Validation Helpers
       ====================================================================== */
    function isValidEmail(email) {
        return /^[\w\-.]+@([\w-]+\.)+[\w-]{2,}$/.test(email);
    }

    function isValidPhone(phone) {
        return /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(phone);
    }

    function setError(inputEl, errorId, message) {
        var errorSpan = document.getElementById(errorId);
        var container = inputEl.closest(".lander-form-item, .form-item");
        if (errorSpan) errorSpan.textContent = message;
        if (container) container.classList.add("has-error");
    }

    function clearError(inputEl, errorId) {
        var errorSpan = document.getElementById(errorId);
        var container = inputEl.closest(".lander-form-item, .form-item");
        if (errorSpan) errorSpan.textContent = "";
        if (container) container.classList.remove("has-error");
    }


    /* ======================================================================
       Field Validators
       ====================================================================== */
    function validateFirstName() {
        var val = firstNameInput.value.trim();
        if (val === "") { setError(firstNameInput, "fname-error", "First name is required."); return false; }
        if (/\d/.test(val)) { setError(firstNameInput, "fname-error", "First name cannot contain numbers."); return false; }
        clearError(firstNameInput, "fname-error");
        return true;
    }

    function validateLastName() {
        var val = lastNameInput.value.trim();
        if (val === "") { setError(lastNameInput, "lname-error", "Last name is required."); return false; }
        if (/\d/.test(val)) { setError(lastNameInput, "lname-error", "Last name cannot contain numbers."); return false; }
        clearError(lastNameInput, "lname-error");
        return true;
    }

    function validateEmail() {
        var val = emailInput.value.trim();
        if (val === "") { setError(emailInput, "email-error", "Email is required."); return false; }
        if (!isValidEmail(val)) { setError(emailInput, "email-error", "Enter a valid email."); return false; }
        clearError(emailInput, "email-error");
        return true;
    }

    function validatePhone() {
        var val = phoneInput.value.trim();
        if (val === "") { setError(phoneInput, "primary-phone-error", "Phone number is required."); return false; }
        if (!isValidPhone(val)) { setError(phoneInput, "primary-phone-error", "Enter a valid phone number."); return false; }
        clearError(phoneInput, "primary-phone-error");
        return true;
    }

    // Attach blur validators
    firstNameInput.addEventListener("blur", validateFirstName);
    lastNameInput.addEventListener("blur", validateLastName);
    emailInput.addEventListener("blur", validateEmail);
    phoneInput.addEventListener("blur", validatePhone);


    /* ======================================================================
       Form Submission (AJAX via WP admin-ajax)
       ====================================================================== */
    form.addEventListener("submit", function (e) {
        e.preventDefault();

        // Run all validators
        var valid = true;
        if (!validateFirstName()) valid = false;
        if (!validateLastName())  valid = false;
        if (!validateEmail())     valid = false;
        if (!validatePhone())     valid = false;

        if (!valid) return;

        // Disable submit to prevent double-clicks
        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting...";

        // Gather form data
        var formData = new FormData(form);
        formData.append("action", "lander_form_submit");

        // Send AJAX request
        fetch(landerPageData.ajaxUrl, {
            method: "POST",
            credentials: "same-origin",
            body: formData,
        })
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if (data.success && data.data && data.data.redirect) {
                window.location.href = data.data.redirect;
            } else if (data.success && data.data) {
                // Unmatched or other status — still redirect to thank-you
                window.location.href = data.data.redirect || landerPageData.thankYou;
            } else {
                // Error from server
                submitBtn.disabled = false;
                submitBtn.textContent = "CONTACT ME";
                alert("There was an issue submitting your form. Please try calling us instead.");
            }
        })
        .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = "CONTACT ME";
            alert("A network error occurred. Please try calling us instead.");
        });
    });

});
